<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200 } = $AppState.theme.colors;
</script>

<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M17.6338 2H14.6338C13.3077 2 12.0359 2.52678 11.0983 3.46447C10.1606 4.40215 9.63379 5.67392 9.63379 7V10H6.63379V14H9.63379V22H13.6338V14H16.6338L17.6338 10H13.6338V7C13.6338 6.73478 13.7391 6.48043 13.9267 6.29289C14.1142 6.10536 14.3686 6 14.6338 6H17.6338V2Z"
    stroke={primary200}
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
